export default __webpack_public_path__ + "static/media/lgp1.612b88f5.png";